// extracted by mini-css-extract-plugin
export default {"root":"MessageProvider_root__6A36N","snackbar":"MessageProvider_snackbar__OFUd-"};